import { computed, observable, makeObservable } from 'mobx';

import { IPlace } from '../models/place';
import { IPrefecture } from '../models/prefecture';
import { IResort } from '../models/resort';
import { IRoute } from '../models/route';

export default class ByPrefecture {
  @observable public isLoading: boolean = false;
  @observable public openIndex: number = null;
  @observable public prefectureIndex: number = 15; // 長野県
  @observable public prefectures: Array<IPrefecture> = [];
  @observable public resorts: Array<IResort> = [];
  @observable public routes: Array<IRoute> = [];
  @observable public update: () => void = () => {};
  @observable public fetchPrefectures: (callback: () => void) => void

  constructor() {
    makeObservable(this);
  }

  @computed get currentPrefecture(): IPrefecture|undefined {
    return this.prefectures.length > 0 && this.prefectures[this.prefectureIndex];
  }

  @computed get mapCenter(): { lat: number, lng: number } {
    const defaultLatLng = { lat: 35.6811673, lng: 139.7670516 }; // 東京駅
    function latLng(resort: IResort) {
      return resort ? { lat: Number(resort.latitude), lng: Number(resort.longitude) } : defaultLatLng;
    }
    if (this.resorts.length > 0) {
      if (this.openIndex != null) {
        return latLng(this.resorts[this.openIndex]);
      }
      return latLng(this.resorts[0]);
    }
    return defaultLatLng;
  }

  @computed get resortListPath(): string|undefined {
    return this.resorts.length > 0  && this.currentPrefecture != null &&
      `/snow/searches/prefecture/${this.currentPrefecture.code}`;
  }

  @computed get kmlURL(): string|undefined {
    // TODO: Place kml files in China friendly server
    return this.currentPrefecture && this.currentPrefecture.kml &&
      `https://static.wamazing.com/geo/${this.currentPrefecture.kml}`;
  }
}
